import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule,MatFormFieldModule,MatInputModule,MatRippleModule } from '@angular/material';
import { GlobalserviceService } from './globalservice.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {NgxPaginationModule} from 'ngx-pagination';
import { AgmCoreModule } from '@agm/core';
import {  ReactiveFormsModule } from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { AppComponent } from './app.component';
import { SigninComponent } from './authentication/signin/signin.component';
import { TopbarComponent } from './topbar/topbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import {MatNativeDateModule, MatSliderModule, DateAdapter} from '@angular/material';



import { RouterModule } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MainpanelComponent } from './mainpanel/mainpanel.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { GenerateqrcodeComponent } from './generateqrcode/generateqrcode.component';
import { AdminUserComponent } from './admin-user/admin-user.component';
import { ODuserComponent } from './oduser/oduser.component';
import { SettingComponent } from './setting/setting.component';
import { ODuserTableComponent } from './oduser-table/oduser-table.component';
import { EnabledialogComponent } from './enabledialog/enabledialog.component';
import { DisableComponent } from './disable/disable.component';
import { ViewMapComponent } from './view-map/view-map.component';
import { CodepopupComponent } from './codepopup/codepopup.component';
import {MatTabsModule} from '@angular/material/tabs';
import { TableFilterComponent } from './table-filter/table-filter.component';
import { MapFilterComponent } from './map-filter/map-filter.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthGuardService } from '../auth-guard.service';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy, DatePipe } from '@angular/common';
import { Approute } from './app.routes';
import { LivedbComponent } from './livedb/livedb.component';
import { AdminmapComponent } from './adminmap/adminmap.component';

//import { AppRouting } from './app.routes';
//import { Approute } from './app/app.routes'

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    TopbarComponent,
    DashboardComponent,
    MainpanelComponent,
    QrcodeComponent,
    GenerateqrcodeComponent,
    AdminUserComponent,
    ODuserComponent,
    SettingComponent,
    ODuserTableComponent,
    EnabledialogComponent,
   DisableComponent,
   ViewMapComponent,
   CodepopupComponent,
   TableFilterComponent,
   MapFilterComponent,
   AuthenticationComponent,
   LivedbComponent,
   AdminmapComponent,



  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
   // Approute,
    RouterModule.forRoot(Approute, { useHash: true }),
   // RouterModule.forRoot(Approute),
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDialogModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    MatTabsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC8QfsG4MM2_b3-fbQ5-C4mImhlrHE5CBk'
    }),
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  exports:[
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    EnabledialogComponent,

  ],
  providers: [
    GlobalserviceService,
    AuthGuardService,
    DatePipe
  ],
  bootstrap: [AppComponent],

  entryComponents:[
    EnabledialogComponent,
    DisableComponent,
    CodepopupComponent
  ]
})
export class AppModule { }
